import { Global } from "../constants/global";
import { ApiEndpoints } from "../constants/apiEndpoints";
import apiClient from "../utils/apiClient";

function clearAllAuthCookies() {
  const projects = [
    Global.JIGENPASSB2B,
    Global.JIGENPASS,
    Global.MEMBERSHIP,
    Global.JIGENPASSBO,
    Global.DOKOKOKO,
  ];
  const names = [Global.ACCESSTOKEN, Global.REFRESHTOKEN];
  const past = "Thu, 01 Jan 1970 00:00:00 GMT";

  projects.forEach((proj) => {
    names.forEach((name) => {
      [`${name}_${proj}`, name].forEach((cookieName) => {
        document.cookie = `${cookieName}=; expires=${past}; path=/`;
        document.cookie = `${cookieName}=; expires=${past}; path=/; domain=${window.location.hostname}`;
      });
    });
  });
}

class AuthService {
  async signup(payload) {
    return await apiClient.post(`${ApiEndpoints.AUTH_B2B}/signup`, payload);
  }

  async verifyInvitation(token) {
    return await apiClient.get(`${ApiEndpoints.AUTH_B2B}/invitations/${token}`);
  }

  async fetchProfile() {
    return await apiClient.get(`${ApiEndpoints.AUTH_B2B}/details`);
  }

  async forgotPassword(payload) {
    return await apiClient.post(
      `${ApiEndpoints.AUTH_B2B}/forgot-password`,
      payload,
    );
  }

  async resetPassword(payload) {
    return await apiClient.post(
      `${ApiEndpoints.AUTH_B2B}/reset-password`,
      payload,
    );
  }

  async login(credentials) {
    return await apiClient.post(`${ApiEndpoints.AUTH_B2B}/login`, credentials);
  }

  async logout() {
    try {
      await apiClient.post(`${ApiEndpoints.AUTH_B2B}/logout`, {});
    } catch {
    } finally {
      clearAllAuthCookies();
    }
  }
}

const authService = new AuthService();
export default authService;
export { authService };
